import React, { useState } from "react";
import Visualizador from "./components/Visualizador";
import Articulos from "./components/Articulos";
import Header from "./components/header";
import Footer from "./components/footer"; // Importar el componente Footer
import BurnComponent from "./components/Burn";

function App() {
  const [activeComponent, setActiveComponent] = useState("visualizador");

  const renderComponent = () => {
    switch (activeComponent) {
      case "articulos":
        return <Articulos />;
      case "burn":
        return <BurnComponent />;
      case "visualizador":
      default:
        return <Visualizador />;
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto',background: 'linear-gradient(90deg, rgb(18, 13, 94) 0%, #1214a0 100%)',
      color: '#fff' }}>
      <Header setActiveComponent={setActiveComponent} />
      <div style={{ flex: 1 }}>
        {renderComponent()}
      </div>
      <Footer /> {/* Añadir el componente Footer */}
    </div>
  );
}

export default App;
